var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['orderable-item', {
  'orderable-item--dragged': _vm.dragged,
  'orderable-item--drop-top': _vm.targeted === -1,
  'orderable-item--drop-bottom': _vm.targeted === 1,
}],on:{"dragover":_vm.handleDragover,"dragleave":_vm.handleDragleave,"drop":_vm.handleDrop}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }